import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import InputField from 'components/LoginForm/Input';

const RegisterConsumer = (props) => (
  <div className="Register">
    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="email"
      fieldName="reg_email"
      fieldPlaceholder={i18n.translate('loginScreen.fields.email')}
      icon="at"
      focus
    />

    <InputField
      change={props.change}
      fieldType="password"
      fieldName="reg_password"
      fieldPlaceholder={i18n.translate('loginScreen.fields.password')}
      icon="key"
      line
    />

    <InputField
      change={props.change}
      fieldType="password"
      fieldName="reg_passwordConfirm"
      fieldPlaceholder={i18n.translate('loginScreen.fields.passwordConfirm')}
      icon="key"
      line
    />

    <span className="hide">
      <InputField
        change={props.change}
        fieldType="text"
        fieldName="reg_agency_name"
        fieldPlaceholder={i18n.translate('loginScreen.fields.agencyName')}
        icon="home"
        required={false}
      />
    </span>

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_first_name"
      fieldPlaceholder={i18n.translate('loginScreen.fields.firstName')}
      icon="user"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_last_name"
      fieldPlaceholder={i18n.translate('loginScreen.fields.lastName')}
      icon="user"
    />

    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="text"
      fieldName="reg_zip_code"
      fieldPlaceholder={i18n.translate('loginScreen.fields.zipCode')}
      icon="map-marker"
    />

    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="text"
      fieldName="reg_custom_1"
      fieldPlaceholder="Promo Code"
      icon="filter"
      required={false}
    />

    <span className="hide">
      <InputField
        change={props.change}
        fieldType="text"
        fieldName="reg_title"
        fieldPlaceholder={i18n.translate('loginScreen.fields.jobTitle')}
        icon="user"
        className="hide"
        required={false}
      />
    </span>

    <div className="Register__type hide">
      <p id="pMan">{i18n.translate('loginScreen.fields.manager')}</p>
      <label htmlFor="manager">
        <input
          onChange={props.change}
          id="manager"
          type="radio"
          name="registration_manager"
          value="manager"
          required={false}
        />
        <span>Yes</span>
      </label>
      <label htmlFor="noManager">
        <input
          onChange={props.change}
          id="noManager"
          type="radio"
          name="registration_manager"
          value="noManager"
          required={false}
        />
        <span>No</span>
      </label>
    </div>

    <span className="hide">
      <InputField
        change={props.change}
        fieldType="text"
        fieldName="reg_city"
        fieldPlaceholder={i18n.translate('loginScreen.fields.city')}
        icon="user"
        required={false}
      />

      <InputField
        change={props.change}
        fieldType="text"
        fieldName="reg_state"
        fieldPlaceholder={i18n.translate('loginScreen.fields.stateProvince')}
        icon="map-marker"
        required={false}
      />

      <InputField
        defaultVal={props.defaultVal}
        change={props.change}
        fieldType="text"
        fieldName="reg_zip_code"
        fieldPlaceholder={i18n.translate('loginScreen.fields.zipCode')}
        icon="map-marker"
        required={false}
      />

      <InputField
        defaultVal={props.defaultVal}
        change={props.change}
        fieldType="tel"
        fieldName="reg_phone_number"
        fieldPlaceholder={i18n.translate('loginScreen.fields.phone')}
        icon="phone"
        required={false}
      />

      <h1 className="hide">
        <b>Describe your agency</b>
      </h1>
      <hr className="short" />
    </span>

    <InputField
      change={props.change}
      fieldLabel="I am open to receiving additional email communications from AAA Travel about the upcoming event and exhibitors I visit during the show."
      fieldName="marketing_opt_in"
      fieldType="checkbox"
      icon="clipboard-check"
      userSelect={false}
      line={false}
      title="I am open to receiving additional email communications from the exhibitors whose booths I have visited during the show, and show sponsors"
    />

    <div className="login__form--buttons">
      <button type="submit" onClick={props.submit} className="Email__input--button">
        {props.loadingAnimRegister ? (
          <span>
            <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
          </span>
        ) : (
          i18n.translate('loginScreen.register')
        )}
      </button>
    </div>
  </div>
);

export default RegisterConsumer;

RegisterConsumer.propTypes = {
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
};

RegisterConsumer.defaultProps = {
  defaultVal: '',
};
